import { Emoji } from 'emoji-mart';
import React from 'react';
import ReactDOM from 'react-dom';

export const emojiRenderer = (emoji, container) => {
  if (emoji) {
    ReactDOM.render(<Emoji size={16} native emoji={emoji} />, container);
  }
};
